const EMAIL_RE = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
const PHONE_RE = /^\+[1-9]\d{9,14}$/;

export function normalizeAlertEmail(value) {
  return String(value || '').trim().toLowerCase();
}

export function isAlertEmail(value) {
  const email = normalizeAlertEmail(value);
  return email.length >= 6 && email.length <= 200 && EMAIL_RE.test(email);
}

/** Digits only, stored as E.164. A 10-digit number is treated as a US number. */
export function normalizeAlertPhone(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length >= 11 && digits.length <= 15) return `+${digits}`;
  return '';
}

export function isAlertPhone(value) {
  return PHONE_RE.test(normalizeAlertPhone(value));
}

/** A sensor id to store, null for every sensor, or undefined when the value is not usable. */
export function alertDeviceId(value) {
  if (value == null || value === '' || value === 'all') return null;
  const id = String(value);
  if (!/^[A-Za-z0-9_-]{1,80}$/.test(id)) return undefined;
  return id;
}
